
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ArcAngelMonitorModeService } from '../arc-angel-monitor-mode.service';
import { Subscription } from 'rxjs';
import { ArcAngelModesService } from '../../../core/services/arc-angel-modes.service';
import { WindowService } from '../../../core/services/window.service';

interface ProcallItem {
  id: string;
  name: string;
  status: string;
  createdAt: string;
  profileId: string;
  getName(): string;
  getFormattedCreatedAtDate(): string;
  getId(): string;
  getProfileId(): string;
}

@Component({
  selector: 'app-procalls-list',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './procalls-list.component.html',
  styleUrl: './procalls-list.component.css'
})
export class ProcallsListComponent implements OnInit, OnDestroy {
  @Input() procall_items: ProcallItem[] = [];

  query: string = '';
  sortOptions: string[] = ['Name', 'Created'];
  sortbyoption: string = '-created';
  statusOptions: string[] = ['All', 'Open', 'Pending'];
  statusOption: string = 'All';

  scrollHeight: string = (window.innerHeight * 0.75) + 'px';

  private procallsSub?: Subscription;

  constructor(
    private monitorModeService: ArcAngelMonitorModeService,
    private arcAngelModesService: ArcAngelModesService,
    private windowService: WindowService
  ) {}

  ngOnInit(): void {
    this.procall_items = this.monitorModeService.data.monitorProcalls;
  }

  ngOnDestroy(): void {
    this.procallsSub?.unsubscribe();
  }

  toUpperCase(str: string): string {
    return str.replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }

  statusOptionClicked(option: string) {
    this.statusOption = option;
  }

  sortOptionClicked(option: string) {
    if (option === 'Created') {
      this.sortbyoption = '-created';
    } else {
      this.sortbyoption = option.toLowerCase();
    }
  }

  getFilteredProcalls(): ProcallItem[] {
    let filtered = this.procall_items;

    if (this.query) {
      filtered = filtered.filter(item =>
        item.getName().toLowerCase().includes(this.query.toLowerCase())
      );
    }

    // Filter by status
    if (this.statusOption !== 'All') {
      filtered = filtered.filter(item =>
        item.status === this.statusOption
      );
    }

    // Sort
    if (this.sortbyoption === '-created') {
      filtered = filtered.sort((a, b) =>
        b.createdAt.localeCompare(a.createdAt)
      );
    } else if (this.sortbyoption === 'name') {
      filtered = filtered.sort((a, b) =>
        a.getName().localeCompare(b.getName())
      );
    }

    return filtered;
  }

  goToDevice(item: ProcallItem) {
  }

  goLiveProcall(event: any, item: ProcallItem) {
    event.stopPropagation();
    this.arcAngelModesService.switchToLiveProcallMode(item.getId());
  }

  getUserProfile(event: any, item: ProcallItem) {
    event.stopPropagation();
    	const data: any = {};
			data.userId = item.getProfileId();
			return this.windowService.openModalWindow(data, 'UserBaseballCardDialogController', 'components/arcangel/users/user-info-dialog.html', undefined, '3%');
  }
}
